import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICameraDeviceParameterRecord } from "@app/main/modules/foundation/_models/_camera-configs/CameraConfigModels";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { IStreamaxCameraProfile } from "@app/services/camera/streamax-camera-profile-service";
import { Observable, tap } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class StreamaxCameraParametersService {

    private streamaxCameraParametersCache: string = "streamaxCameraParametersCache";
    constructor(
        private readonly dataCacheService: DataCacheService,
        private readonly http: HttpClient
    ) { }

    getLatestParameterRecords(invalidateCache = false): Observable<ICameraDeviceParameterRecord[]> {
        return this.dataCacheService.getOrRequest(this.streamaxCameraParametersCache, () => this.getLatestParameterRecordsFromDb(), { invalidateCache });
    }    

    getParameterRecordsFromDb(): Observable<ICameraDeviceParameterRecord[]> {
        return this.http.get<ICameraDeviceParameterRecord[]>(`/api/camera/parameters`);
    }

    getLatestParameterRecordsFromDb(): Observable<ICameraDeviceParameterRecord[]> {
        return this.http.get<ICameraDeviceParameterRecord[]>(`/api/cameras/parameters/latest`);
    }

    reassessRecordDeviations(profile: IStreamaxCameraProfile): Observable<ICameraDeviceParameterRecord[]> {
        return this.http.post<ICameraDeviceParameterRecord[]>(`/api/cameras/parameters/reassess/${profile.AccountId}`, profile).pipe(tap(updatedRecords => {
            updatedRecords.map(record => {
                this.dataCacheService.addOrUpdateItem(record, this.streamaxCameraParametersCache);
                return updatedRecords;
            });
        }));
    }

    runTestBuild(): Observable<number> {
        return this.http.get<number>(`/api/cameras/parameters/build`);
    }
}
